import { featureItems } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-4">
            平台优势
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-900">
            为什么选择拷贝漫画
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-lg mx-auto">
            五大核心优势，打造极致的免费漫画阅读体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
          {featureItems.map((feature) => (
            <div
              key={feature.id}
              className="group bg-background-50 border border-background-200 rounded-xl p-6 text-center hover:border-primary-200 hover:bg-background-100 transition-all duration-300 cursor-pointer"
            >
              <div className="w-14 h-14 mx-auto flex items-center justify-center bg-primary-50 rounded-xl group-hover:bg-primary-100 transition-colors">
                <i className={`${feature.icon} text-primary-500 text-2xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mt-4">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 mt-2 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}